<template>
<append-to-body class="close-todo-alarm">
  <close-alarm ref="closeAlarm" @onHide="$emit('closeButtonClicked')" @onClose="submit"></close-alarm>
</append-to-body>
</template>
<script>
import appendToBody from '../appendToBody'
import closeAlarm from '@/pages/dataSearch/common/closeAlarm'

export default {
  name: 'closeTodoAlarm',
  components: {
    appendToBody,
    closeAlarm
  },
  props: {
    alarmData: Object
  },
  data () {
    return {}
  },
  methods: {
    async submit (data) {
      this.$refs.closeAlarm.startLoading()
      try {
        const formData = { id: this.alarmData.id, remarks: data.remarks, jobNo: data.jobOrder }
        await this.$store.dispatch('CloseTodoAlarm', formData)
        this.$message({ message: '关闭成功', type: 'success', showClose: true })
        this.$emit('alarmClosed', { alarmData: this.alarmData, formData })
      } catch (e) {
        console.log(e)
      }
      this.$refs.closeAlarm.endLoading()
    }
  },
  mounted () {
    this.$refs.closeAlarm.show()
  }
}
</script>
<style lang="less" scoped>
.close-todo-alarm {
}
</style>



// WEBPACK FOOTER //
// src/components/notification/closeTodoAlarm.vue